// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1rZuC","productName":"Table_productName__1LmTA"};